import { useSetAtom } from 'jotai'
import { useTranslation } from 'next-i18next'
import { startTransition } from 'react'
import { Button } from 'ui/src/components/Button/Button'
import { Text } from 'ui/src/components/Text/Text'
import { ChevronIcon } from 'ui/src/icons/Chevron'
import { SSN_SE_SECTION_ID } from '@/components/PriceCalculator/SsnSeSection'
import { usePriceCalculatorStep } from '@/features/priceCalculator/usePriceCalculatorStep'
import { useActiveFormSectionId } from '../../../useActiveFormSectionId'
import { usePriceCalculatorForm } from '../../../usePriceCalculatorForm'
import { priceCalculatorShowEditSsnWarningAtom } from '../../priceCalculatorAtoms'
import { sectionNavigationWrapper } from './SectionNavigation.css'

export function SectionNavigation() {
  const { t } = useTranslation('purchase-form')
  const form = usePriceCalculatorForm()
  const { activeFormSectionId, setActiveFormSectionId } = useActiveFormSectionId()
  const setShowEditSsnWarning = useSetAtom(priceCalculatorShowEditSsnWarningAtom)
  const { setStep } = usePriceCalculatorStep()

  const activeSectionIndex = form.sections.findIndex((section) => section.id === activeFormSectionId)
  const previousSection = form.sections[activeSectionIndex - 1]
  const sectionIndicatorLabel = t('SECTION_NAVIGATION_INDICATOR_LABEL', {
    currentSection: activeSectionIndex + 1,
    totalSections: form.sections.length,
  })

  const buttonLabel =
    previousSection.id === SSN_SE_SECTION_ID
      ? t('SECTION_NAVIGATION_BUTTON_LABEL_EDIT_SSN')
      : t('SECTION_NAVIGATION_BUTTON_LABEL')

  const handlePreviousSection = () => {
    startTransition(() => {
      if (previousSection.id === SSN_SE_SECTION_ID) {
        setShowEditSsnWarning(true)
      } else {
        setStep('fillForm')
        setActiveFormSectionId(previousSection.id)
      }
    })
  }

  return (
    <div className={sectionNavigationWrapper}>
      <Button
        size="small"
        variant="secondary"
        // Optically align the icon with the text
        Icon={<ChevronIcon style={{ marginTop: -1 }} size="0.75rem" direction="left" />}
        onClick={handlePreviousSection}
      >
        {buttonLabel}
      </Button>
      <Text color="textSecondary" size="sm">
        {sectionIndicatorLabel}
      </Text>
    </div>
  )
}
